import * as React from "react";
import { useState, useEffect } from "react";
import clsx from "clsx";
import { Input, Tooltip, withStyles } from "@material-ui/core";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from "react-google-maps";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import imageMap from "common/assets/images/ilustracao_mapa.png";

const styles = (theme) => ({
  listContainer: {
    left: "calc(50% - 306px)",
    position: "absolute" as any,
    zIndex: 900,
  },
  option: {
    backgroundColor: "#FFFFFF",
    cursor: "pointer",
    width: `612px`,
    margin: "auto",
    height: 40,
    fontSize: 14,
    boxShadow: "0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)",
  },
  optionActive: {
    backgroundColor: "#E0E0E0",
  },
  description: {
    verticalAlign: "center",
    lineHeight: "40px",
    overflow: "hidden",
  },
  inputAddress: {
    fontFamily: "Roboto",
    fontSize: "23px",
    fontWeight: 400,
    width: "612px",
    margin: "0 auto",
    marginTop: "25px",
    display: "block",
  },
  mapContainer: {
    margin: "30px 0px 20px",
    "& img": { border: "1px solid #D5D5D5" },
  },
  map: {
    border: "1px solid #ABC200",
    width: `614px`,
    margin: "auto",
  },
});

const googleURL =
  "https://maps.googleapis.com/maps/api/js?key=AIzaSyBtgxlwXL5H4XZ4FqtZkSxggMw9hSflGyY&v=3.exp&libraries=geometry,drawing,places";

export function initGoogleMap() {
  const element = document.getElementById("scriptMapId");
  if (!element) {
    const script = document.createElement("script");
    script.src = googleURL;
    script.async = true;
    script.id = "scriptMapId";
    document.body.appendChild(script);
  }
}

interface IProps {
  label: string;
  address: string;
  onChange: (address: string) => void;
  disabled: boolean;
  classes: any;
}

const PlaceWithMapField = ({
  label,
  address,
  onChange,
  disabled = false,
  classes,
}: IProps) => {
  const [selectedAddress, setSelectedAddress] = useState(address);
  const [coords, setCoords] = useState({ lat: 0, lng: 0 });

  const searchOptions = {
    componentRestrictions: { country: ["br"] },
  };

  useEffect(() => {
    handleSelect(address);
  }, [address]);

  const handleSelect = (value: string) => {
    handleChange(value);
    if (!value) return;

    geocodeByAddress(value)
      .then((results) => getLatLng(results[0]))
      .then((latLng) => {
        const newCoords = { lat: latLng.lat, lng: latLng.lng };
        setCoords(newCoords);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleChange = (value: string) => {
    if (selectedAddress === value) return;
    setSelectedAddress(value);
    onChange(value);
  };

  const CustomMap: any = withScriptjs(
    withGoogleMap((props: any) => (
      <GoogleMap
        defaultCenter={coords}
        options={{
          streetViewControl: false,
          mapTypeControlOptions: { mapTypeIds: [] },
          disableDefaultUI: true,
          panControl: false,
          zoomControl: false,
          zoom: 16,
        }}
      >
        {props.isMarkerShown && <Marker position={coords} />}
      </GoogleMap>
    ))
  );

  return (
    <>
      <PlacesAutocomplete
        searchOptions={searchOptions}
        value={selectedAddress}
        onChange={handleChange}
        onSelect={handleSelect}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
          <div>
            <Input
              {...getInputProps({ placeholder: "Type address" })}
              inputProps={{
                style: { textAlign: "center" },
                maxLength: "300",
              }}
              className={classes.inputAddress}
              placeholder={label}
              disabled={disabled}
            />

            <div
              className={clsx(
                "autocomplete-dropdown-container",
                classes.listContainer
              )}
            >
              {loading && <div>{"Carregando..."}</div>}
              {suggestions.map((suggestion) => {
                const className = suggestion.active
                  ? "suggestion-item--active"
                  : "suggestion-item";

                return (
                  <div
                    {...getSuggestionItemProps(suggestion, {
                      className: clsx(className, classes.option, {
                        [classes.optionActive]: suggestion.active,
                      }),
                    })}
                  >
                    {suggestion.description.length > 88 ? (
                      <Tooltip title={suggestion.description}>
                        <span className={classes.description}>
                          {suggestion.description.substr(0, 85) + "..."}
                        </span>
                      </Tooltip>
                    ) : (
                      <span className={classes.description}>
                        {suggestion.description}
                      </span>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </PlacesAutocomplete>
      <div className={classes.mapContainer}>
        {!coords.lat ? (
          <img src={imageMap} />
        ) : (
          <div className={classes.map}>
            <CustomMap
              isMarkerShown
              googleMapURL={googleURL}
              loadingElement={<div style={{ height: `100%` }} />}
              containerElement={
                <div
                  style={{
                    height: `202px`,
                    width: `612px`,
                    margin: "auto",
                  }}
                />
              }
              mapElement={<div style={{ height: `100%` }} />}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default withStyles(styles)(PlaceWithMapField);



// WEBPACK FOOTER //
// ./src/modules/development/components/layouts/PlaceWithMapField.tsx